import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/vue-currency-input';
import '@/assets/css/main.css';
import '@/assets/css/spending.css';
import DateRangePicker from '@gravitano/vue-date-range-picker';
import middleware from './router/middleware';
import isFilter from './mixins/filter';
import ACLService from './services/ACLService';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueApexCharts from 'vue-apexcharts';
import './plugins/vue-currency-input';
import amountField from './components/amountField';
import './plugins/vee-validate';
import VueScrollTo from 'vue-scrollto';
import PerfectScrollbar from 'vue-perfect-scrollbar';
import VueCookies from 'vue-cookies';
import 'remixicon/fonts/remixicon.css';

// CI/CD Retry Count: 1

Vue.use(VueCookies);
Vue.use(VueScrollTo);
Vue.use(VueApexCharts);

Vue.component('apexchart', VueApexCharts);
Vue.component('v-currency-field', amountField);
Vue.component('v-perfect-scroll', PerfectScrollbar);

const permissions = [
  {
    name: 'dashboard',
    permission: 'view'
  }
];

window.ACLService = new ACLService(permissions);

// Load route middleware
middleware.register({ store, router });

Vue.config.productionTip = false;

Vue.use(DatePicker);
Vue.use(DateRangePicker);
Vue.mixin(isFilter);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
